import { render } from "./IconBarcodeScanFrame.vue?vue&type=template&id=3699aa1e"
import script from "./IconBarcodeScanFrame.vue?vue&type=script&lang=ts"
export * from "./IconBarcodeScanFrame.vue?vue&type=script&lang=ts"
script.render = render

export default script